import React, { useState } from 'react';
import FtpFileBrowser from './FtpFileBrowser';

const AdminFileManagerPage = ({ clickChangeMenu }) => {
    // We reuse the existing FtpFileBrowser but keep it effectively "open"
    // Note: FtpFileBrowser is designed as a modal with fixed position overlay.
    // For a cleaner 100% parity, we will render it.
    
    return (
        <div style={{ height: '700px', position: 'relative' }}>
            <FtpFileBrowser 
                isOpen={true} 
                onClose={() => clickChangeMenu('home')} 
                onSelectFile={(file) => console.log("Selected:", file)} 
            />
            <div style={{ padding: '20px' }}>
                <h3>Trình quản lý tập tin</h3>
                <p>Hệ thống đang hiển thị trình duyệt tệp tin trực tiếp từ Server.</p>
            </div>
        </div>
    );
};

export default AdminFileManagerPage;
